<template>
    <div>
        <a-drawer
          :title='title'
          :visible="visbleTree"
          v-bind="drawerConfig"
          :body-style="{ paddingBottom: '80px' }"
          @close="onClose"
        >
         <a-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</a-checkbox>
          <div class="w-tree-wrapper">
          <a-tree
            :checked-keys="checkedKeys"
            checkable
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :selected-keys="selectedKeys"
            :replaceFields="replaceFields"
            :tree-data="treeData"
            @expand="onExpand"
            @check="onCheck"
          />
          <a-spin v-if="loading" tip="加载中..." class="spin-overlay" />
          </div>
          <div class="drawer-btn"  >
            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">确定</a-button>
            <a-button @click="onClose">取消</a-button>
          </div>
        </a-drawer>
    </div>
</template>

<script>
import API from "../api";
import {drawerConfig} from "../../../../utils/utils"

export default {
      name: "TreeForm",
      props:["visbleTree", "title", "roleId"],
      data(){
        return {
          checkAll: false,
          replaceFields: { children: 'children', title: 'label', key: 'id' },
          expandedKeys: [],
          autoExpandParent: true,
          checkedKeys: [],
          halfCheckedKeys: [],
          selectedKeys: [],
          treeData: [],
          checked_menu_ids: [],
          allMenuIds: [],
          drawerConfig: drawerConfig,
          form: { menu_ids: "", role_id: "" },
          loading: false,
        }
      },
    watch: {
      checkedKeys(val) {
        this.form.menu_ids = val;
      },
      visbleTree(newVal) {
        if (newVal && this.roleId) {
          this.getData();
        }
      },
      roleId: function (newVal) {
        if (newVal) {
          this.form.role_id = newVal;
        }
      }
    },
    methods:{
      getLeafIds(list) {
        let leafIds = [];
        list.forEach(item => {
          if (!item.children || item.children.length === 0) {
            leafIds.push(item.id);
          } else {
            leafIds = leafIds.concat(this.getLeafIds(item.children));
          }
        });
        return leafIds;
      },
      mergeNameAndType(list) {
        list.forEach(item => {
          item.label = item.name + ' (' + (item.component_type || '') + ')';
          if (item.children && item.children.length > 0) {
            this.mergeNameAndType(item.children);
          }
        });
      },
      getData() {
        this.loading = true;
        API.serverManagement.GET_SET_DATA(this.roleId).then(res => {
          console.log('rest--', res)
          this.treeData = res.data.data['menu_list']
          this.checked_menu_ids = res.data.data.checked_menu_ids || []

          const leafIds = this.getLeafIds(this.treeData);
          this.checkedKeys = this.checked_menu_ids.filter(id => leafIds.includes(id));


          // this.checkedKeys = [...this.checked_menu_ids];
          this.allMenuIds = this.collectAllIds(this.treeData)
          this.checkAll = this.allMenuIds.length > 0 &&
              this.allMenuIds.every(id => this.checkedKeys.includes(id))
          this.mergeNameAndType(this.treeData);
        }).catch(() => {
          this.treeData = []
          this.checkedKeys = []
          this.allMenuIds = []
        }).finally(() => {
          this.loading = false
        })
      },
      collectAllIds(list) {
        let ids = [];
        list.forEach(item => {
          ids.push(item.id);
          if (item.children && item.children.length > 0) {
            ids = ids.concat(this.collectAllIds(item.children));
          }
        });
        return ids;
      },
      handleCheckAllChange(val) {
        if (this.checkAll) {
          this.checkedKeys = [...this.allMenuIds];
        } else {
          this.checkedKeys = [];
        }
      },
      onExpand(expandedKeys) {
        this.expandedKeys = expandedKeys;
        this.autoExpandParent = false;
      },
      onCheck(checkedKeys, e) {
        this.checkedKeys = checkedKeys;
        this.halfCheckedKeys = e.halfCheckedKeys || [];
        this.checkAll = this.allMenuIds.length > 0 &&
        this.allMenuIds.every(id => checkedKeys.includes(id));
      },
      onSelect(selectedKeys, info) {
        this.selectedKeys = selectedKeys;
      },
      onClose() {
        this.checkAll = false;
        this.selectedKeys = [];
        this.checkedKeys = [];
        this.allMenuIds = [];
        this.treeData = [];
        this.$emit("changVisible", false);
      },
      onSubmit() {

        this.form.menu_ids = [...this.checkedKeys, ...(this.halfCheckedKeys || [])];
        console.log("----", this.form);
        API.serverManagement.SET_SUBMIT(this.form).then(res => {
          if (res && res.data && res.data.code === 200) {
            this.$message.success("保存成功");
            this.onClose();
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        }).catch(() => {
          this.$message.error("保存失败");
        });
      },
      },
  }
</script>
<style scoped>
.w-tree-wrapper {
  position: relative;
  min-height: 100vh;
}
.spin-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
}
:deep(.w-tree-wrapper .ant-tree-node-content-wrapper) {
  max-width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:deep(.w-tree-wrapper .ant-tree-title) {
  max-width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>
